import { Injectable } from '@angular/core';
import { HttpService } from '../security/http.service';
import { StorageService } from '../shared/storage.service';
import { Http, Headers, URLSearchParams } from '@angular/http';
import { Appsettings } from '../../configuration/appsettings';
import { FileContent } from '../../models/catalogs/file.model';

import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';

// Model
import { Event } from '../../models/content/event.model';
@Injectable({
  providedIn: 'root'
})
export class EventService {

   // URL del blog que vamos a trabajar con su REST API
   public URL = 'https://hlmra.com/';
   public API = `${this.URL}wp-json/wl/v1/acceso`;

  constructor(  public storageService: StorageService,
                private httpService: HttpService,
                private http: HttpClient) { }


  // Guarda un registro de evento de clic
  addEventClic( data: Event) {
    const API_URL = `${Appsettings.API_ENDPOINT_FULL}/EventReport`;
    const HEADERS = new Headers();
    HEADERS.append('Content-Type', 'application/json');

    // const params = {
    //   'id': contentId,

    // };

   return this.httpService.post(API_URL, JSON.stringify( data ), { headers: HEADERS } )
                           .map( res => res.json());
  }


  getUserWp() {
    // return this.httpService.get(API_URL, JSON.stringify( data ), { headers: HEADERS } )
    //                        .map( res => res.json());

    // return  this.httpService.get(API_URL);

    return this.http.get(`${this.API}`);

  }

  createCupon1() {
    const URL = '/wp-json/wc/v3/coupons';
    const HEADERS = new Headers();

    HEADERS.append('Content-Type', 'application/json');

    const params = {
      code: "RAPRUEBA-1",
      discount_type: "percent",
      amount: "10",
      individual_use: true,
      exclude_sale_items: true,
      minimum_amount: "100.00"
    };
    return this.httpService.post(URL, JSON.stringify(params), { headers: HEADERS })
    .map(res => res.json());

  }

    createCupon(params): Observable<any>{
      let nombre = 'roman'
      const URL = `https://www.ellibrero.com?usuario=${nombre}`;
      //const URL = `?usuario=${nombre}`;



      let json = JSON.stringify(params);
      let headers = new HttpHeaders();

      headers.set('Content-Type','application/json');
      headers.set('Access-Control-Allow-Origin','http://www.ellibrero.com/');


      return this.http.post(URL, json, {headers: headers});
  }
}

